import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { IImage } from '~/src/repositories/Container/schema/IImage'
import { DeleteCheckboxForm } from './DeleteCheckbox.styles'

export const DeleteCheckbox: React.FC<{
  data: IImage
  deleteIds: string[]
  setDeleteIds: Dispatch<SetStateAction<string[]>>
}> = ({ data, deleteIds, setDeleteIds }): JSX.Element => {
  const [isChecked, setIsChecked] = useState<boolean>(false)

  const onChangeDeleteCheck = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      setDeleteIds([...deleteIds, e.target.value])
    } else {
      deleteIds.splice(deleteIds.indexOf(e.target.value, 1))
      setDeleteIds([...deleteIds])
    }
  }

  useEffect(() => {
    if (deleteIds.includes(String(data.id))) {
      setIsChecked(true)
    } else {
      setIsChecked(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteIds])

  return (
    <DeleteCheckboxForm
      key={`checkbox-${data.id}`}
      id={data.id as unknown as string}
      checked={isChecked}
      onChange={onChangeDeleteCheck}
      value={data.id as unknown as string}
      sx={{
        background: 'rgba(255, 255, 255, 0.8)',
        borderRadius: '2px',
      }}
    />
  )
}
